import React, { useContext, useEffect, useMemo, useState } from "react";
import Input from "../../../../../../stories/Input/Input";
import ItemsAutocomplete from "../../../../../../customComponents/ItemsAutocomplete";
import { FilterBarProps } from "../../../maps/ticketdetails/TicketsRaisedList";
import useServerDateandTime from "../../../../../../customHooks/useServerDateandTime";
import {
  convertToTimeZone,
  CustomModal,
  ticketPriorityClassName,
  ticketStatusClassName,
  toInputStandardDate,
  toIsoDate,
  toStandardDate,
} from "../../../../../../utils/UtilFunctions";
import {
  debouncedDelay,
  DEFAULT_TIME,
  emptyFunc,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
  ticketPriorirityOptions,
  ticketStatusOptions,
} from "../../../../../../utils/constants";
import useLabels from "../../../../../../customHooks/useLabels";
import MultiplePrioritySelect from "../../../../../../customComponents/MultiplePrioritySelect";
import {
  PriorityOptionsTypes,
  TableHeaderProps,
  TicketStatusOptionsTypes,
} from "../../../../../../utils/types";
import MultipleTicketStatusSelect from "../../../../../../customComponents/MultipleTicketStatusSelect";
import SuppliersSelect from "../../../purchase/purchaseorder/rfqtopo/components/SuppliersSelect";
import { responseType } from "../../../../../../utils/formTypes";
import { LdgrQueryType } from "../../../masters/supplier/queries/types";
import { TableType } from "../../../../customer/companies/queries/types";
import { TextField } from "@mui/material";
import dayjs from "dayjs";
import Compare from "../../../../../../images/Compare.svg";
import { StyledDatagrid } from "../../../../../../styles/DatagridStyles";
import {
  GridColDef,
  GridAlignment,
  GridColumnVisibilityModel,
} from "@mui/x-data-grid-pro";
import useAssetTableJson from "../../../../../../json/useAssetTableJson";
import { MapsContext } from "../../../maps/context/context";
import { mapsPayloadType } from "../../../maps/context/reducer";
import EyeWhite from "../../../../../../images/EyeWhite.svg";
import DownloadDoc from "../../../../../../images/DownloadImage.svg";
import { TABLE_ROW_HEIGHT } from "../../../../../../styles/Variables";
import {
  AtsTicketsOrderField,
  GetTicketsData,
  GetTicketsVars,
  TicketEdge,
  TicketsQueryType,
} from "../../../../../../queries/types";
import { TimeZone } from "../../../../../../utils/Enum.types";
import { GetTickets } from "../../../../../../queries/queries";
import { useLazyQuery } from "@apollo/client";
import { ColumnVisibilityFor } from "../../../../../../utils/Enum.Datagrid";
import { OrderDirection } from "../../../../../../utils/commonQueryTypes";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import RaisedTicketDetails from "../../../maps/ticketing/junctionDetails/raisedTickets/RaisedTicketDetails";
import {
  ViewAssetStylesRaiseTicket,
  ViewRaisedTicketModalStyles,
} from "../../../../../../styles/CustomModalStyles";
import { StateTypes } from "../../../maps/Maps";
import { AssetDetailsPageFor } from "../../../maps/ticketing/junctionDetails/raisedTickets/AssetDetails";
import { Button } from "../../../../../../stories/Button/Button";
import Add from "../../../../../../images/Add.svg";
import RaiseTicket from "../../../reports/ticketwise/RaiseTicket";
import { useDebounce } from "../../../../../../customHooks/useDebounce";

const TableDetails = () => {
  const { serverDate } = useServerDateandTime();
  const { state, dispatch } = useContext(MapsContext);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [searchData, setSearchData] = useState<string>("");
  const debouncedSearch = useDebounce(searchData, debouncedDelay);
  const [tickets, setTickets] = useState<TicketEdge[]>([]);
  const { company_id, customer_id, sub_id, siteID, junctionID } =
    useUrlParams();
  const { user_details } = useLoggedInUserDetails();
  const [raiseTicket, setRaiseTicket] = useState(false);

  const { Maps } = useAssetTableJson();
  const [tableType, setTableType] = useState<TableType>(TableType.COMPANY);
  const [viewDetails, setViewDetails] = useState(false);

  const [filterFormData, setFilterFormData] = useState<FilterBarProps>({
    asset: 0,
    assetStatus: "",
    priority: "",
    searchData: "",
    ticketReason: "",
    ticketStatus: "",
    date: "",
    subsidiary: 0,
    endDate: "",
    fromDate: "",
  });

  const [prioritySelected, setPrioritySelected] = useState<
    PriorityOptionsTypes[]
  >([]);
  const [statusSelected, setStatusSelected] = useState<
    TicketStatusOptionsTypes[]
  >([]);

  const [ticketDetails, setTicketDetails] = useState<StateTypes>({
    flag: false,
    itemId: 0,
    tableLevel: TableType.COMPANY,
  });
  const { itemLabel } = useLabels();

  const dynamicHeaders: TableHeaderProps[] = Maps.RaisedTicketDetails.map(
    (header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      renderCell: (params) => {
        if (header.field === "actions") {
          return (
            <>
              <button
                className="tkt-raised-list__tableblock--view"
                onClick={() => {
                  dispatch({
                    type: mapsPayloadType.ASSET_TYPE_ID,
                    payload: {
                      assetTypeId: params.row.tableId,
                    },
                  });
                  dispatch({
                    type: mapsPayloadType.TICKET,
                    payload: {
                      ticketId: params.row.ticket_id,
                    },
                  });
                  setTableType(params.row.tableLevel);
                  setTicketDetails({
                    flag: true,
                    itemId: params.row.ticket_id,
                    tableLevel: TableType.COMPANY,
                  });
                }}
              >
                View Details <img src={EyeWhite} alt="" />
              </button>
            </>
          );
        } else if (header.field === "priority") {
          return (
            <>
              <div
                className={ticketPriorityClassName(params.row.priority)}
                style={{ margin: "auto", height: 25 }}
              >
                {params.row.priority}
              </div>
            </>
          );
        } else if (header.field === "attachments") {
          return (
            <>
              <div className={`tkt-raised-list__tableblock--attachments`}>
                {params.row.attachments} <img src={DownloadDoc} alt="" />
              </div>
            </>
          );
        } else if (header.field === "ticket_status") {
          return (
            <>
              <span
                className={ticketStatusClassName(params.row.ticket_status)}
                style={{ margin: "auto" }}
              >
                {params.row.ticket_status}
              </span>
            </>
          );
        } else return params.value;
      },
    })
  );
  const columns: GridColDef[] = [...dynamicHeaders];
  const [GetTicket, { data, loading, fetchMore }] = useLazyQuery<
    GetTicketsData,
    GetTicketsVars
  >(GetTickets);

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetTickets.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCustomer) => {
          const filteredStudent = tickets.find(
            (ticket) => ticket.node.id === newCustomer.node.id
          );
          if (filteredStudent) {
            return {
              ...newCustomer,
              node: {
                ...newCustomer.node,
              },
            };
          }
          return newCustomer;
        });

        setTickets(updatedNewData);
      } else {
        setTickets(newData);
      }

      setEndCursor(data.GetTickets.pageInfo.endCursor);
      setHasNextPage(data.GetTickets.pageInfo.hasNextPage);
    } // eslint-disable-next-line
  }, [loading, data]);
  useEffect(() => {
    if (customer_id) {
      GetTicket({
        variables: {
          after: null,
          first: ROWS_PER_PAGE,
          name: debouncedSearch,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsTicketsOrderField.TICKET_NO,
          },

          companyID: company_id
            ? company_id
            : state.company
            ? state.company.node.id
            : 0,
          customerID: customer_id,
          subsidiaryID: sub_id
            ? sub_id
            : state.subsidary
            ? state.subsidary.node.id
            : 0,
          reason: filterFormData.ticketReason
            ? filterFormData.ticketReason
            : "",
          startDate: filterFormData.fromDate
            ? toIsoDate(filterFormData.fromDate)
            : undefined,
          endDate: filterFormData.endDate
            ? toIsoDate(filterFormData.endDate)
            : undefined,
          input: {
            itemID: filterFormData.asset ? filterFormData.asset : 0,
            ldgrID: 0,
            stckCategoryID: 0,
            stckGroupID: 0,
            stckManufacturerID: 0,
            stckSubCategoryID: 0,
            stckUomID: 0,
            query_type: TicketsQueryType.ALL,
            itemDetailsID: 0,
            status: statusSelected.map((status) => status.value),
            priority: prioritySelected.map((priority) => priority.value),
            empID: user_details.id ? user_details.id : 0,
          },
          siteID: siteID ? siteID : state.site ? state.site.value : 0,
          junctionID: junctionID
            ? junctionID
            : state.junction
            ? state.junction.node.id
            : 0,
        },
      });
    }
  }, [
    GetTicket,
    debouncedSearch,
    company_id,
    customer_id,
    sub_id,
    state.subsidary,
    state.company,
    state.junction,
    state.site,
    filterFormData.priority,
    filterFormData.ticketStatus,
    filterFormData.asset,
    filterFormData.ticketReason,
    prioritySelected,
    statusSelected,
    user_details.id,
    filterFormData.fromDate,
    filterFormData.endDate,
  ]);
  const rows = useMemo(() => {
    return data
      ? data.GetTickets.edges
          .filter(({ node }) => node.status !== "CLOSED")
          .map(({ node }, index) => ({
            id: index + 1,
            logNo: node.ticketNo,
            asset: node.item.desc,
            asset_slno: node.itemDetails.prodSerialNo,
            ticket_date: toStandardDate(node.ticketDate),
            subsidiary: node.subsidiaryDetails.name,
            subsidiary_site: node.site.name,
            ticket_reason: node.reason,
            status: node.status,
            maintained_by: node.itemDetails.vendorDetails.desc,
            attachments: "",
            priority: node.priority,
            ticket_status: node.status,
            ticket_id: node.id,
            junction: node.junction.name,
            asset_id: node.itemDetails.id,
            tableId:
              node.tableLevel === TableType.ASSET
                ? node.itemDetails.id
                : node.junctionID,
            tableLevel: node.tableLevel,
            closedDuration: node.closedDuration,
            company: node.company.name,
            poleNum: node.poleNum,

            closedDate:
              toStandardDate(node.closedDate) !== toStandardDate(DEFAULT_TIME)
                ? convertToTimeZone(TimeZone.Asia_Kolkata, node.closedDate)
                    .timeAndDate
                : "-",
          }))
      : [];
  }, [data]);
  const handleScroll = () => {
    if (hasNextPage && !loading) {
      fetchMore({
        variables: {
          first: FETCH_MORE_DATA,
          after: endCursor,
        },
        updateQuery: (prevResult, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prevResult;

          const newEdges = fetchMoreResult.GetTickets.edges;
          const pageInfo = fetchMoreResult.GetTickets.pageInfo;

          setEndCursor(pageInfo.endCursor);
          setHasNextPage(pageInfo.hasNextPage);

          const duplicateCheck = prevResult.GetTickets
            ? prevResult.GetTickets.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              )
            : [];

          if (duplicateCheck.length > 0) return prevResult;

          return {
            GetTickets: {
              edges: [...tickets, ...newEdges],
              pageInfo,
              totalCount: data ? data.GetTickets.totalCount! : 0,
            },
          };
        },
      });
    }
  };
  useEffect(() => {
    if (serverDate) {
      setFilterFormData({
        ...filterFormData,
        fromDate: toInputStandardDate(serverDate),
        endDate: toInputStandardDate(serverDate),
      });
    }
  }, [serverDate]);
  useEffect(() => {
    setStatusSelected(
      filterFormData.ticketStatus
        ? ticketStatusOptions.filter(
            (item) => item.value === filterFormData.ticketStatus
          )
        : []
    );
  }, [ticketStatusOptions, filterFormData.ticketStatus]);

  useEffect(() => {
    if (filterFormData.priority) {
      setPrioritySelected(
        ticketPriorirityOptions.filter(
          (item) => item.value === filterFormData.priority
        )
      );
    }
  }, [ticketPriorirityOptions, filterFormData.priority]);
  const [columnVisibilityModel, setColumnVisibilityModel] =
    React.useState<GridColumnVisibilityModel>({
      id: true,
      ticket_date: true,
      logNo: true,
      company: false,
      subsidiary: false,
      subsidiary_site: false,
      asset: false,
      poleNum: false,
      ticket_reason: false,
      maintained_by: false,
      resolvedDate: true,
      closedDate: false,
      ticket_status: true,
      priority: true,
      resolvedDuration: false,
      closedDuration: false,
      actions: true,
    });
  useEffect(() => {
    const savedVisibilityModel = localStorage.getItem(
      ColumnVisibilityFor.TICKET_LIST_REPORT
    );
    if (savedVisibilityModel) {
      setColumnVisibilityModel(JSON.parse(savedVisibilityModel));
    }
  }, []);

  return (
    <div className="vld-tkt-details">
      <div className="vld-tkt-details__flex">
        <b>Active Tickets</b>
        <div className="overall-total-count">
          Total Tickets : <b>{rows.length}</b>
        </div>
      </div>
      <div className="vld-tkt-details__filters row g-0">
        <div className="col-2">
          <Input
            id="data_search"
            placeholder="Search..."
            onChange={(e) => {
              setSearchData(e.target.value);
            }}
          />
        </div>
        <div className="col-2">
          <ItemsAutocomplete
            onChange={(newValue) => {
              if (newValue) {
                setFilterFormData({
                  ...filterFormData,
                  asset: newValue.value,
                });
              } else {
                setFilterFormData({
                  ...filterFormData,
                  asset: 0,
                });
              }
            }}
            onKeyDown={emptyFunc}
            value={filterFormData.asset}
            label={itemLabel}
            placeholder=""
          />
        </div>
        <div className="col-2 asset-reports__right--multiple-select">
          <MultiplePrioritySelect
            onChange={(newValue) => {
              setPrioritySelected(newValue);
            }}
            onKeyDown={emptyFunc}
            autoCompleteValue={prioritySelected}
            handleClear={emptyFunc}
            label="Ticket Priority"
          />
        </div>
        <div className="col-2 asset-reports__right--multiple-select">
          <MultipleTicketStatusSelect
            onChange={(newValue) => {
              setStatusSelected(newValue);
            }}
            onKeyDown={emptyFunc}
            value={statusSelected}
            handleClear={emptyFunc}
            label="Ticket Status"
          />
        </div>

        <div className="col">
          <div className="tkt-raised-list__select--flex">
            <TextField
              label="From date"
              className="asset-reports__right--textfield"
              slotProps={{
                inputLabel: { shrink: true },
              }}
              type="date"
              onChange={(e) => {
                if (
                  dayjs(e.target.value).isAfter(dayjs(filterFormData.endDate))
                ) {
                  return;
                }
                setFilterFormData({
                  ...filterFormData,
                  fromDate: e.target.value,
                });
              }}
              value={filterFormData.fromDate}
            />

            <img src={Compare} alt="" />
            <TextField
              label="To date"
              className="asset-reports__right--textfield"
              slotProps={{
                inputLabel: { shrink: true },
              }}
              type="date"
              onChange={(e) => {
                if (
                  dayjs(e.target.value).isBefore(dayjs(filterFormData.fromDate))
                ) {
                  return;
                }
                setFilterFormData({
                  ...filterFormData,
                  endDate: e.target.value,
                });
              }}
              value={filterFormData.endDate}
            />
          </div>
          <div className="col flex-end">
            <Button
              onClick={() => {
                setRaiseTicket(!raiseTicket);
              }}
            >
              <img src={Add} alt="/" />
              Raise New Ticket
            </Button>
          </div>
        </div>
      </div>
      <div className="vld-tkt-details__table">
        {rows.length ? (
          <StyledDatagrid
            columns={columns}
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            // onCellClick={(params) => {
            //   if (params.field === "actions") {
            //     dispatch({
            //       type: mapsPayloadType.TICKET,
            //       payload: {
            //         ticketId: params.row.ticket_id,
            //       },
            //     });

            //     // if (params.row.status === TicketStatus.CLOSED) {
            //     //   setAssetdetails({
            //     //     flag: true,
            //     //     itemId: params.row.asset_id,
            //     //   });
            //     // } else {
            //     //   setRaisedTicketModal({
            //     //     flag: true,
            //     //     itemId: params.row.asset_id,
            //     //   });
            //     // }
            //   }
            // }}
            disableRowSelectionOnClick
            hideFooter
            initialState={{
              pinnedColumns: {
                left: ["id", "ticket_no", "asset", "asset_id"],
                right: ["actions"],
              },
            }}
            onRowsScrollEnd={() => {
              handleScroll();
            }}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) =>
              setColumnVisibilityModel(newModel)
            }
          />
        ) : (
          <b className="nodata">No data found</b>
        )}
      </div>

      <CustomModal
        style={ViewRaisedTicketModalStyles}
        isOpen={ticketDetails.flag}
        onRequestClose={() =>
          setTicketDetails({
            flag: false,
            itemId: 0,
            tableLevel: TableType.COMPANY,
          })
        }
        contentComponent={
          <RaisedTicketDetails
            setModalFlag={() =>
              setTicketDetails({
                flag: false,
                itemId: 0,
                tableLevel: TableType.COMPANY,
              })
            }
            assetType={tableType}
            pageFor={AssetDetailsPageFor.MAPS}
          />
        }
      />

      <CustomModal
        isOpen={raiseTicket}
        style={ViewAssetStylesRaiseTicket}
        onRequestClose={() => setRaiseTicket(!raiseTicket)}
        contentComponent={<RaiseTicket setModalFlag={setRaiseTicket} />}
      />
    </div>
  );
};

export default TableDetails;
